<template>
  <b-dropdown
    id="actions-dropdown"
    :disabled="disabled"
    toggle-tag="div"
    toggle-class="p-0 bg-transparent"
    hide-on-click-out
    @hide="onDropdownHide"
  >
    <template #button-content>
      <McButton
        v-bind="buttonProps"
        variant="secondary"
        icon="icon-outline_chevron-down"
        icon-position="right"
        :text="resolvedButtonText"
        :disabled="disabled"
      />
    </template>

    <template v-for="(item, index) in menuItems">
      <!-- Single item -->
      <b-dropdown-item
        v-if="!item.children"
        :key="index"
        :class="item.class"
        @click="handleAction(item.handler)"
      >
        <template v-if="$scopedSlots[item.key]" v-slot:[item.key]="item">{{
          $scopedSlots[item.key](item)
        }}</template>
        <template v-else>{{ item.label }}</template>
      </b-dropdown-item>

      <!-- Multilevel dropdown -->
      <b-dropdown-item
        v-else
        :key="index"
        :class="['multilevel-dropdown', item.class]"
        @click="handleAction(() => {}, false)"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>{{ item.label }}</span>
          <i class="icon-outline_chevron-right"></i>
        </div>
        <div class="gap-filler"></div>
        <div class="multilevel-dropdown-menu pr-2">
          <div class="dropdown-menu">
            <b-dropdown-item
              v-for="(child, childIndex) in item.children"
              :key="childIndex"
              :class="child.class"
              @click="handleAction(child.handler)"
            >
              <template v-if="$scopedSlots[child.key]" v-slot:[child.key]="child">{{
                $scopedSlots[child.key](child)
              }}</template>
              <template v-else>{{ child.label }}</template>
            </b-dropdown-item>
          </div>
        </div>
      </b-dropdown-item>
    </template>
  </b-dropdown>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: null,
    },
    menuItems: {
      type: Array,
      default: () => [],
    },
    buttonProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      okToHide: true,
    }
  },
  computed: {
    resolvedButtonText() {
      return this.buttonText !== null ? this.buttonText : this.$t('global.field.action')
    },
  },
  methods: {
    handleAction(handler, shouldClose = true) {
      if (typeof handler === 'function') {
        handler()
      }
      if (!shouldClose) {
        this.okToHide = false
      }
    },
    onDropdownHide(bvEvent) {
      if (!this.okToHide) {
        bvEvent.preventDefault()
        this.okToHide = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>